/**
 * Exécute toutes les promesses sans s'arrêter au premier reject et les résoud
 * avec le retour en premier paramètre et l'erreur éventuelle en second.
 * @param {Array} promises Tableau de   promesses
 */
export function settled(promises) {
    return Promise.all(
        promises.map(
            (p) =>
                new Promise((resolve) => {
                    p.then((o) => resolve({ result: o, error: null })).catch((error) => resolve({ result: null, error }));
                }),
        ),
    );
}

export const dateFormat = 'DD-MM-YYYY';

export function deepCloneElement(element) {
    return JSON.parse(JSON.stringify(element));
}

export function getRisk(risk) {
    switch (risk) {
        case 'P':
            return 'cotisations.call.foresight';
        case 'S':
            return 'cotisations.call.health';
        case 'R':
            return 'cotisations.call.retirement';
        default:
            return risk;
    }
}

export function getStatus(status) {
    switch (status) {
        case '1':
            return 'affiliations.affiliates.affiliated';
        case '0':
            return 'affiliations.affiliates.standBy';
        default:
            return 'affiliations.affiliates.standBy';
    }
}

export function getCotisationStatus(status) {
    switch (status) {
        case 'P':
            return 'cotisations.call.paid';
        case 'I':
            return 'cotisations.call.imPaid';
        case 'A':
            return 'cotisations.call.waiting';
        case 'S':
            return 'cotisations.call.noFollowUp';
        case 'D':
            return 'cotisations.call.mustDu';
        default:
            return status;
    }
}

export const uniqueArray = ({ data, key }) => {
    let uniqueObjArray = [...new Map(data.filter((item) => item.value).map((item) => [item['value'], item])).values()];
    return uniqueObjArray;
};

export const compare = (a, b) => {
    if (a.label < b.label) {
        return -1;
    }
    if (a.label > b.label) {
        return 1;
    }
    return 0;
};

export const makeUniqueAndSort = (data) => {
    data.sort(compare);
    return uniqueArray({ data: data, key: 'value' });
};

export const delay = async (time = 10) => {
    return await new Promise((resolve) => {
        setTimeout(resolve, time);
    });
};

/** Convert object to array of options with value/label properties
 * @return array - [{ value: key, label: value }]
 */
export const objectToOptionsArr = (object) => {
    let options = [];
    for (const [key, value] of Object.entries(object)) {
        options.push({ value: value, label: key });
    }
    return options;
};
/** Reorder alphabetically + numerically array of objects by label
 * E.G. options=[{value:'x, label:'x'}]
 * @return array - orderOptions = [{value:'x, label:'x'}]
 */
export const orderedOptions = (options) => {
    const list = options.map((e) => e.label);
    const ne = (str) => str.replace(/\d+/g, (n) => n.padStart(8, '0'));
    const nc = (a, b) => ne(a).localeCompare(ne(b));
    const sortedKeys = list.sort(nc);
    const orderOptions = sortedKeys.map((o) => {
        return options.find((opt) => opt.label === o);
    });
    return orderOptions;
};

/** Cumul data */
export const cumulData = (total, num) => {
    if (!num) return total;
    return parseFloat(total) + parseFloat(num);
};

export const calculPourcentage = (total, value) => {
    return ((100 * parseFloat(value)) / parseFloat(total)).toFixed(2);
};

/**
 * Reorder object property from another object ordered
 * if property are missing in ordered object, they are added at the end
 * @param {*} object - { prop2:'XX, prop1:'YY'}
 * @param {*} orderedObject -  { prop1:'', prop2:''}
 * @returns {object} - { prop1:'YY', prop2:'XX'}
 */
export const reorderObjProps = (object, orderedObject) => {
    const orderedList = {};
    const keyUsed = [];
    // reorder list
    for (const [key] of Object.entries(orderedObject)) {
        keyUsed.push(key);
        if (object[key]) orderedList[key] = object[key];
    }
    // Add missing properties
    for (const [key] of Object.entries(object)) {
        if (!keyUsed.includes(key)) orderedList[key] = object[key];
    }

    return orderedList;
};

/** Convert special caracters */
export const convertSpecialCharacters = (str) => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
